import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../../services/common';
import { environment } from '../../../../environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-rera-mindmap',
  templateUrl: './rera-mindmap.component.html',
  styleUrl: './rera-mindmap.component.scss'
})
export class ReraMindmapComponent implements OnInit {
  mapId: any
  baseUrl: string = environment.apiEndpoint; // Base URL of the application
  mapUrl: any;
  url: any;

  constructor(public commonService: CommonService, private sanitizer: DomSanitizer, private router: Router, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.getMapId()
    this.showMap(false);
  }

  getMapId() {
    //first check if mapid came in url (it will come in case of acquisition -> kml --> khasra click 
    //as every khasra has its own map id)
    this.mapId = this.route.snapshot.paramMap.get("mapId");
    if (this.mapId == null || this.mapId == undefined) {
      if (window.location.origin.toLowerCase().indexOf('a2ginfra') > -1)
        this.mapId = '3841010452'
      else {
        if (this.router.url.toLowerCase().indexOf('rera') > -1)
          this.mapId = '3861930833'; // Replace with your actual map ID
        else if (this.router.url.toLowerCase().indexOf('sale-client-wise-map') > -1)
          this.mapId = 3855533893
        else if (this.router.url.toLowerCase().indexOf('documap') > -1)
          this.mapId = 3858009097
      }
    }
  }

  showMap(cliecked?: boolean) {
    //   this.url = `/assets/mindmap/map-viewer.html?mapId=${this.mapId}&apiBase=${this.baseUrl}`;
    //   this.mapUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    if (this.mapId) {

      this.url = "https://www.mindmeister.com/maps/public_map_shell/" + this.mapId + "/map-for-manu-bhoomi-team?width=600&height=600&z=auto&no_share=1&no_logo=1"
      this.mapUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    }
    else {
      if (cliecked)
        alert("Please enter the Map ID");
    }
  }
}
